import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-165" data-mp="3kqw54mwtl6h6">
      <div className="mx-auto max-w-5xl" data-id="element-166" data-mp="3fz5mzurn5ef7">
        <h2 className="text-center font-display text-[1.75rem] font-black leading-tight tracking-tight text-ink sm:text-[2.4rem]" data-id="element-167" data-mp="3fxuly2pkykrs">
          What Coaches Are Saying
        </h2>
        <p className="mt-3 flex items-center justify-center gap-2 text-sm font-medium text-ink/70" data-id="element-168" data-mp="3700ub52rgfay">
          <span className="flex items-center gap-0.5" aria-hidden="true" data-id="element-169" data-mp="31z3ako23rd7c">
            {Array.from({
            length: 5
          }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-amber-500 text-amber-500" data-id="element-170" data-mp="2x2w5sylg07qz" data-mpi={index} />)}
          </span>
          <span data-id="element-171" data-mp="v85b00rzzj4d">4.9/5 · +2,000 Coaches</span>
        </p>

        <div className="mx-auto mt-10 grid max-w-4xl gap-5 sm:grid-cols-2" data-id="element-172" data-mp="qaljw0a7bbv0">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl bg-sand p-6" data-id="element-173" data-mp="h5oq3c5zm87y">
              <div className="flex items-center gap-0.5" aria-label="5 out of 5 stars" data-id="element-174" data-mp="m6cgbvme6l14">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-amber-500 text-amber-500" aria-hidden="true" data-id="element-175" data-mp="c73p3aiwvkig" data-mpi={index} />)}
              </div>
              <blockquote className="mt-4 font-display text-sm italic leading-relaxed text-ink/85" data-id="element-176" data-mp="q6mkr3ujd3dv">
                &ldquo;{item.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-auto pt-6" data-id="element-177" data-mp="v3wm9hv795i2">
                <p className="text-xs font-bold text-ink" data-id="element-178" data-mp="1iv1yzo5ufho5">{item.name}</p>
                <p className="text-xs text-ink/50" data-id="element-179" data-mp="1nm0isxq1ixw5">{item.location}</p>
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-8 text-center text-[11px] text-ink/40" data-id="element-180" data-mp="1xgxyr8zk05lw">
          Illustrative placeholder testimonials.
        </p>
      </div>
    </section>;
}